// extracted by mini-css-extract-plugin
module.exports = {"solutions":"solutions_solutions__iYRwh"};